// extracted by mini-css-extract-plugin
export default {"tableContainer":"OrganizationProfiles_tableContainer__+GdlU","header":"OrganizationProfiles_header__+qhAJ","link":"OrganizationProfiles_link__Gnc3r"};